
<div class='container'>
 <div class="row recur-align1">
  <h2 class="heading-adfsclient">{{'Add a Recurring Rule'|translate}}</h2><br><br>
     <div class="col-sm-6 recur-main-txt ">
       {{'Note that all times are East Coast USA'|translate}}
     </div>
     <div class="col-sm-6">

    </div>
 </div>
 <div class="row recur-align1">
    <div class="col-sm-2 recur-rule-txt">
      {{'Description'|translate}}
    </div>
    <div class="col-sm-6">
   <input  type="text" class="recur-input recur-slt" name="description" id="description" [(ngModel)]="description">
   <div *ngIf="isDescErr" class="desc-err">{{'Please enter a description of this rule'|translate}}</div>
   </div>
</div>
<div class="row">
    <div class="col-sm-2 recur-rule-txt">
      {{'Start day of the week'|translate}}
    </div>
    <div class="col-sm-6">
        <select [(ngModel)]="day" class="recur-slt">
            <option *ngFor="let day of daysList" [value]="day"> {{day}}</option>
        </select>
   </div>
</div>
<div class="row">
    <div class="col-sm-2 recur-rule-txt">
     {{'Start time'|translate}}
    </div>
    <div class="col-sm-6">
        <select [(ngModel)]="week" class="recur-slt">
            <option *ngFor="let week of weekList" [value]="week"> {{week}}</option>
        </select>: <select [(ngModel)]="weekOne" class="recur-slt">
            <option *ngFor="let weekOne of weekOneList" [value]="weekOne"> {{weekOne}}</option>
        </select>

   </div>
</div>
<div class="row">
    <div class="col-sm-2 recur-rule-txt">
    {{'Duration in hours'|translate}}
    </div>
    <div class="col-sm-10">
        <input class="recur-in" type="text" name="hours" id="hours" [(ngModel)]="hours" ><br>
       
   </div>
   <div class="row">
    <div class="col-sm-2 recur-rule-txt">
   
    </div>
    <div class="col-sm-10">
       
       <div class="col-sm-6 recur-main-txt recur-wrap">NB: {{'offroad rule text'|translate}}.</div> 
       <div *ngIf="isHoursErr" class="desc-err">{{'Please select the number of hours this rule applies for'|translate}}.</div>
   </div>
   <div class="row">
    <div class="col-sm-2 recur-rule-txt">
      {{'enabled'|translate}}
    </div>
    <div class="col-sm-6">
        <input  type="checkbox" class="checkEnable" name="hours" id="hours" [(ngModel)]="isCheck" >
   </div>
</div>
<div class="col-sm-2 recur-rule-txt">
   
  </div>
  <div class="col-sm-6">
    <button  class="reccurring-btn" name="uploadXml"  (click)="add()">{{'add'|translate}}</button>&nbsp;
    <button  class="reccurring-btn" name="uploadXml"  (click)="cancel()">{{'Cancel'|translate}}</button>
 </div>
</div>


</div>